import { render, staticRenderFns } from "./infl-attribute.vue?vue&type=template&id=af79bda8&"
import script from "./infl-attribute.vue?vue&type=script&lang=js&"
export * from "./infl-attribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('af79bda8', component.options)
    } else {
      api.reload('af79bda8', component.options)
    }
    module.hot.accept("./infl-attribute.vue?vue&type=template&id=af79bda8&", function () {
      api.rerender('af79bda8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/infl-attribute.vue"
export default component.exports